export const oteljsVersion = 'dev';
